const apiConstant = {
    API_URL: "https://api.indiacontentgrievance.amcplus.com"
}

export default apiConstant
